import Button from "../../atoms/Button/Button";
import "./ProfessionalsSection.css";

const ProfessionalsSection = () => (
  <section id="professionnels">
    <div className="wrap">
      <div className="split">
        <div className="prof-text">
          <span className="eyebrow">
            Aux professionnels de la prévention et de la lutte contre les
            incendies
          </span>
          <h2 className="prof-h2">
            Une donnée plus fine, pour des décisions plus sûres 
            <span className="prof-h2-accent">
              gratuite pour les acteurs publics
            </span>
          </h2>
          <div className="prof-rule" />
          
          <div className="prof-checklist">
            <p>
              Découvrez <strong>SecuFire Action</strong>, est un écosystème
              de modules d'aide à la décision : prévisions météo de haute
              précision, modélisation de la propagation des feux (modèle
              Balbi), cartographie de la végétation et de la topographie,
              mémoire tactique des incendies passés, points d'eau, zonage
              DFCI, etc. Mobilisés ensemble ou progressivement, ces modules
              viennent enrichir l'expertise des professionnels— sans jamais
              s'y substituer : la décision, en toutes circonstances reste la leur.
            </p>
            <p className="gratuit-p">
              SecuFire Action est mis gratuitement à disposition des acteurs français de la prévention
              et de la lutte contre les feux de végétation.
            </p>
            <p className="prof-footnote">
              * Le modèle Balbi et al. de propagation du feu est un modèle
              physique de réputation mondiale développé par l'équipe
              scientifique du « Projet Feu » du Laboratoire SPE de
              l'Università di Corsica Pasquale Paoli.
            </p>
          </div>

          <div className="prof-buttons">
            <a
              href="/Presentation_ECI_Secufire_Action.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="prof-cta-link"
              download="/Presentation_ECI_Secufire_Action.pdf"
 
            >
              <Button
                label="Télécharger la présentation de  SecuFire Action"
                variant="orange"
              />
            </a>
            <a
              href="mailto:info@ensemblepourlaforet.fr?subject=Demande%20de%20d%C3%A9monstration%20gratuite%20de%20SecuFire%20Action"
              className="prof-cta-link"
            >
              <Button
                label="Demander une démonstration gratuite de SecuFire Action"
                variant="primary"
              />
            </a>
          </div>
        </div>
        <div className="prof-visual">
          <img
            className="section-illustration"
            src="/images/sfa2.png"
            alt="SecuFire Action, écosystème de modules d'aide à la décision"
          />
        </div>
      </div>
    </div>
  </section>
);

export default ProfessionalsSection;